import { Breakpoint, useMediaQuery, useTheme } from "@mui/material";

export default function useBreakPointUp(breakpoint: Breakpoint): boolean {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.up(breakpoint), { noSsr: false });
}
